import Accordion from "react-bootstrap/Accordion";

function AccordionGeneral({ list }) {
  return (
    <Accordion id="virtual-banking" defaultActiveKey={null}>
      {list.map((item, index) => (
        <Accordion.Item
          eventKey={index}
          data-aos="fade-down"
          // data-aos-delay={`${index}00`}
          key={index}
        >
          <Accordion.Header className="no-margin-smallscreen">
            <div className="d-inline-flex align-items-center">
              <div className="p-2">
                <h3 style={{ color: "#000045", margin: "0" }}>{item.title}</h3>
              </div>
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <div data-aos="fade-up">
              <div className="position-relative d-flex flex-1 flex-column gap-6 py-1 md:gap-10">
                <div className="position-relative z-0 d-flex gap-6 pl-1.5 md:gap-8">
                  <div>
                    <p>{item.date}</p>
                    <p>{item.content}</p>
                    {item.image && (
                      <div className="d-flex align-items-center justify-content-left">
                        <img
                          src={item.image}
                          alt={item.imageAlt || "Image"}
                          style={{
                            maxWidth: "100%",
                            marginTop: "10px",
                            marginBottom: "40px",
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <p>{item.subcontent}</p>
            </div>
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}

export default AccordionGeneral;
